define('empty.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('empty', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<section class=\"trackingso-info-card\"><span class=\"trackingso-info-card-content\"></span></section>";
},"useData":true}, 'extensions/AOTT/TrackingSO/1.0.0/', 'extensions/AOTT/TrackingSO/1.0.0/', Handlebars);
});